import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { connect } from "react-redux";
import Grid from '@mui/material/Grid';
import { Button } from "@mui/material";
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useDispatch } from "react-redux";
import TabContext from '@mui/lab/TabContext';
import AddIcon from '@mui/icons-material/Add';
import LoaderComponent from "../components/LoaderComponent";
import InterpretationFiles from "../components/InterpretationFiles";
import { loadControllersList } from "../api/controllerpermissionsapi";
import InterpretationFileModal from "../components/InterpretationFileModal";
import { addNewInterpretationFile, loadInterpretationFilesList } from "../api/interpretationfileapi";
import { closeInterpretationFileDialog, openInterpretationFileDialog } from "../state/interpretationfile/actions";
import { getControllersList, getInterpretationFilesDialogStatus, getInterpretationFilesList, getInterpretationFilesLoading } from "../selector/selectors";
import ProductFilter from "../components/ProductFilter";

function ManageHomePageInterpretationFiles({
  isLoading,
  interpretationFilesList,
  addNewInterpretationFile,
  startLoadingInterpretationFiles,
  interpretationFileDialogBoxStatus,
  controllersList
}) {
    const dispatch = useDispatch();
    const [page, setPage]   = React.useState(0);
    const [value, setValue] = React.useState('1');
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [controller, setController]   = React.useState('');
   
    const [interpretationFormData, setInterpretationFormData] = useState({
        releaseNotes:'',
        controllerId: '',
        isLatest: false
    });

    const [interpretationFile, setInterpretationFile] = useState('');

    useEffect(() => {
      startLoadingInterpretationFiles();
      dispatch(loadControllersList());
    }, [startLoadingInterpretationFiles,dispatch]);

    useEffect(() => {
        if(interpretationFileDialogBoxStatus === false) {
            setInterpretationFile('');
            setInterpretationFormData({
                releaseNotes:'',
                controllerId: '',
                isLatest: false
            });
        }
    }, [interpretationFileDialogBoxStatus]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleClickOpenRole = () => {
        document.activeElement.blur(); 
        dispatch(openInterpretationFileDialog());
    };

    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        startLoadingInterpretationFiles(pageVal,rowsPerPage,controller);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        startLoadingInterpretationFiles(0,event.target.value,controller);
    }

    const onClickChangeList=(controllerId)=>{
        setPage(0);
        setController(controllerId);
        startLoadingInterpretationFiles(0,rowsPerPage,controllerId);
    }

    const handleFormData = () => {
        const formData = new FormData(); 
        if(interpretationFormData.length === 0 || interpretationFormData.controllerId === '' || interpretationFormData.releaseNotes === '' || interpretationFile === ''){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }
        formData.append('uploadedFile', interpretationFile);
        Object.keys(interpretationFormData).forEach(key => formData.append(key, interpretationFormData[key]));
        addNewInterpretationFile(formData);
        if(interpretationFileDialogBoxStatus === false) {
            dispatch(closeInterpretationFileDialog());
        }
    }

    const handleResetFilter = () => {
        setPage(0);
        setController('');
        startLoadingInterpretationFiles();
    }

    return (
        <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Tab label="Home Page Interpretation Files" value="1" />
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <Grid container sx={{ paddingBottom: 1, display: 'flex', justifyContent: 'space-between' }}>
                                <Grid>
                                    <ProductFilter controllersList={controllersList?.data} onClickChangeList={onClickChangeList} selectedControllerId={controller} />
                                </Grid>
                                <Grid>
                                    <Button 
                                        sx={{marginRight:2}}
                                        variant="contained"
                                        size="medium"
                                        color="primary"
                                        onClick={handleClickOpenRole}
                                     >
                                        <AddIcon fontSize="medium"  sx={{paddingRight:1}} /> Add
                                    </Button> 
                                    <Button 
                                        variant="contained"
                                        size="medium"
                                        color="error"
                                        onClick={handleResetFilter}
                                     >
                                        Reset Filter
                                    </Button>
                                </Grid>
                            </Grid>
                            <InterpretationFiles filesList={interpretationFilesList} page={page} rowsPerPage={rowsPerPage} handleChangeRowsPerPage={handleChangeRowsPerPage} handleChangePage={handleChangePage} />
                        </TabPanel>
                    </Grid>
                </TabContext>
                <InterpretationFileModal
                    open={interpretationFileDialogBoxStatus || false}
                    value={interpretationFormData}
                    setInterpretationFormData={setInterpretationFormData}
                    interpretationFile={interpretationFile}
                    setInterpretationFile={setInterpretationFile}
                    handleFormData={handleFormData}
                    controllers={controllersList}
                />
            </Grid>
        </Box>
    );
}

const mapStateToProps = (state) => ({
  isLoading: getInterpretationFilesLoading(state),  
  interpretationFilesList:getInterpretationFilesList(state),  
  interpretationFileDialogBoxStatus: getInterpretationFilesDialogStatus(state),
  controllersList: getControllersList(state)
});

const mapDispatchToProps = (dispatch) => ({
    addNewInterpretationFile: (data)  => dispatch(addNewInterpretationFile(data)),
    startLoadingInterpretationFiles: (page,rowsPerPage,controller) => dispatch(loadInterpretationFilesList(page,rowsPerPage,controller)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageHomePageInterpretationFiles);

